import { render, staticRenderFns } from "./CIBNform.vue?vue&type=template&id=0d429c84&scoped=true"
import script from "./CIBNform.vue?vue&type=script&lang=js"
export * from "./CIBNform.vue?vue&type=script&lang=js"
import style0 from "./CIBNform.vue?vue&type=style&index=0&id=0d429c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d429c84",
  null
  
)

export default component.exports